module.exports = __webpack_public_path__ + "mods/slumgud_-_sigil_of_valhalla.mod";